import {useEffect, useMemo, useState} from "react";
import GHIconButton from "../../../../components/GHIconButton";
import CustomService from "../../../../services/custome.service";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import {dayNames, holidayColumns} from "../../../../components/Utils/HeaderColumns";

export function useLoadDataTable(clickItem) {

  const [rows, setRows] = useState([]);
  const [columns] = useState(holidayColumns); 

  useEffect(() => {
    CustomService.getHolidays()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); 

  return {
    columns: columns,
    rows: rows
      ? rows.map((element) => ({
          name: element.name,
          holiday: element.holiday_date
            ? element.holiday_date.split("T")[0]
            : "",
          weekday: dayNames[element.week_day],
          action: (
            <GHIconButton
              onClick={clickItem}
              id={element.id}
              title="Delete"
              icon="delete"
              size="small"
              color="error"
            />
          ),
        }))
      : [],
  };
}
